import React from 'react';
import { useSelector } from 'react-redux';

import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const Breadcrumbs = (props) => {

  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));

  const {
    data,
  } = props;

  if (!data) {
    return null;
  }

  return (
    <div className={`Breadcrumbs ${data.length === 1 ? 'Breadcrumbs__small' : ''}`}>
      <div className="icon icon-chevron-right extra-icon" />
      <div className="Breadcrumbs__home">
        <div>
          <CoreLink to={`/${currentLanguage}`} aria-label="To homepage">
            <div className="icon icon-home icon-variant-4" />
            <span className="Breadcrumbs__home__title">Home</span>
          </CoreLink>
        </div>
      </div>
      {data.map((breadcrumb, index) => {
        const { url, title } = breadcrumb;
        return (
          <div key={!url ? title : url} className="Breadcrumbs__item">
            {url ? (
              <div>
                <div className="icon icon-chevron-right icon-variant-4" />
                <CoreLink to={url}>
                  {title}
                </CoreLink>
              </div>
            ) : (
              <div className="current">
                <div className="icon icon-chevron-right icon-variant-4" />
                <span>{title}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
